<template>
  <div>
    <base-screen>
      <el-form :inline="true" :model="param" label-position="left"
               class="demo-form-inline"
               ref="screenForm"
               @keydown.native.enter="searchSubmit"
               @submit.native.prevent>
        <el-form-item label="模板名称：" prop="name">
          <el-input v-model="param.name" placeholder="模板名称"></el-input>
        </el-form-item>
        <el-form-item label="审核状态：" prop="checkFlag">
          <el-select v-model="param.checkFlag" placeholder="请选择审核状态">
            <el-option label="全部" value=''></el-option>
            <el-option label="未审核" value="0"></el-option>
            <el-option label="已审核" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <el-button type="primary" @click="openDialog(null, '0')" v-pms="'add'">添加模板</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        boder
        style="width: 100%">
        <el-table-column
          label="模板名称"
          prop="name"
          width="150"
          >
          <template slot-scope="scope">
            <el-button type="text" class="link" @click="openDialog(`${scope.$index}`, '2')" v-pms="'look'">{{scope.row.name}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="模板内容"
          >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200">
        </el-table-column>
        <el-table-column
          prop="checkState"
          label="审核状态"
          width="120">
          <template slot-scope="{row}">
            <div v-if="row.checkFlag">已审核</div>
            <div v-if="!row.checkFlag">未审核</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="openDialog(`${scope.$index}`, '1')" type="text" v-if="!scope.row.checkFlag"
                       size="small" v-pms="'edit'">编辑
            </el-button>
            <el-button @click="deleteSmsTemplate(`${scope.$index}`)" type="text" size="small" v-pms="'delete'" v-if="!scope.row.checkFlag">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
    <el-dialog
      :title="editMsg"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      :modal="false"
      :v-loading="submitting">
      <div class="add-form">
        <el-form
          ref="form"
          :model="dialogData"
          label-width="94px"
          :rules="rules">
          <el-form-item
            prop="name"
            label="模板名称"
          >
            <el-input type="text" v-model="dialogData.name" placeholder="请填写模板名称" :readonly="lookFlag"></el-input>
          </el-form-item>
          <el-form-item label="模板内容：" prop="content">
            <el-input class="el-input"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入短信模板内容"
                      v-model="dialogData.content"
            :readonly="lookFlag">
            </el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input class="el-input"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入备注"
                      v-model="dialogData.remark" :readonly="lookFlag">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;">关 闭</el-button>
        <el-button type="primary" @click="submitSmsTemplate" style="width: 100px;" v-show="!lookFlag">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {sms} from '../../api'
import {SMS_PROJECT_CODE, SMS_PROJECT_NAME} from '../../constants'
export default {
  name: 'SmsTemplate',
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      param: {
        name: '',
        checkFlag: '',
        projectCode: SMS_PROJECT_CODE,
        subCode: this.$store.state.user.orgCode
      },
      tableDataLoading: false,
      lookFlag: false, // 是否查看时只读
      submitting: false,
      editMsg: '',
      dialogFormVisible: false,
      dialogData: {
        smsTemplateId: '',
        projectCode: SMS_PROJECT_CODE,
        projectName: SMS_PROJECT_NAME,
        subCode: this.$store.state.user.orgCode,
        subName: this.$store.state.user.orgName,
        name: '',
        content: '',
        checkFlag: false,
        createUser: this.$store.state.user.userId,
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入模板名称', trigger: 'blur'},
          {max: 10, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入短信模板内容', trigger: 'blur'},
          {max: 255, message: '长度不能超过255个字符', trigger: 'blur'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'blur'},
          {max: 255, message: '长度不能超过255个字符', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await sms.getTemplatePage({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    searchSubmit () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.param.name = ''
      this.param.checkFlag = ''
      this.page.pageNum = 1
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    deleteSmsTemplate (index) {
      let smsTemplateId = this.tableData[index].smsTemplateId
      let name = this.tableData[index].name
      this.$confirm(`确定要删除模板[${name}]吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await sms.deleteTemplate({smsTemplateId: smsTemplateId})
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '模板删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '模板删除失败'
          })
        }
      })
    },
    openDialog (index, flag) {
      if (index == null) {
        this.lookFlag = false
        this.editMsg = '添加短信模板'
        this.dialogData.name = ''
        this.dialogData.content = ''
        this.dialogData.remark = ''
      } else {
        if (flag === '1') {
          this.lookFlag = false
          this.editMsg = '编辑短信模板'
          let data = this.tableData[index]
          delete data.createTime
          this.dialogData = data
        } else {
          this.lookFlag = true
          this.editMsg = '查看短信模板'
          let data = this.tableData[index]
          delete data.createTime
          this.dialogData = data
        }
      }
      this.dialogFormVisible = true
    },
    submitSmsTemplate () { // 添加编辑
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.dialogData.smsTemplateId) {
            this.addSmsTemplate()
          } else {
            this.editSmsTemplate()
          }
        } else {
          return false
        }
      })
    },
    async addSmsTemplate () { // 添加方法
      this.submitting = true
      let {code, data, msg} = await sms.addTemplate(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '短信模板添加成功，等待审核'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '短信模板添加失败'
        })
      }
    },
    async editSmsTemplate () { // 编辑方法
      this.submitting = true
      let {code, msg} = await sms.updateTemplate(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '短信模板修改成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '短信模板修改失败'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
